import styled, { css } from 'styled-components/macro';
import { IButtonContainerProps } from './types';

export const ButtonContainer = styled.div<IButtonContainerProps>`
  display: flex;

  ${({ retainOrderOnMobile }) =>
    retainOrderOnMobile
      ? css`
          flex-direction: column;
          button:not(:first-child) {
            margin-top: 0.5rem;
          }
        `
      : css`
          flex-direction: column-reverse;
          button:not(:first-child) {
            margin-bottom: 0.5rem;
          }
        `};

  @media only screen and (min-width: 768px) {
    display: block;
    text-align: ${({ align }) => align ?? 'right'};

    button:not(:first-child) {
      margin-bottom: 0;
      margin-top: 0;
      margin-left: 0.5rem;
    }
  }
`;
